/*
# -----------------------------------------------------------------------------
# Component: motorDataMixin.js
# Author: antonio.ramirez@pst.sg
# Created Date: 08/Feb/2020
# Comments: Responsible for shared components - Motor Parameters
# -----------------------------------------------------------------------------
*/
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export const motorDataMixin = {
  data() {
    return {
      sideFunction: [
        {
          text: 'LTA Parameters',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'ltaParam' }
        },
        {
          text: 'Motor NCD Rate',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'mtrNCD' }
        },
        {
          text: 'Motor Standard Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'mtrStandardTxt' }
        },
        // {
        //   text: 'Motor Vehicle Group',
        //   icon: 'mdi-tune',
        //   iconColor: 'primary',
        //   params: { name: 'mtrVehGrp' }
        // },
        {
          text: 'Motor Vehicle Make',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'mtrVehMake' }
        },
        {
          text: 'Motor Vehicle Model',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'mtrVehModel' }
        },
        {
          text: 'Motor Vehicle Type',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'mtrVehType' }
        },
        {
          text: 'Motor Vehicle Usage',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'mtrVehUsg' }
        }
      ]
    }
  },
  methods: {
    doInit(pKey) {
      const apiURI = this.menu.motorParamList
      if (apiURI) {
        const params = {
          paramKey: pKey,
          paramString: ''
        }
        this.loading = true
        this.$http.get(expandURI(apiURI, params)).then(result => {
          this.items = []
          const { data } = result.data
          if (data) {
            data.map(result => {
              const convertList = {
                paramName: result.paramName,
                paramRef: result.paramRef,
                paramDesc: result.paramDesc,
                paramPrmtStts: result.paramPrmtStts
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    }
  },
  components: {
    SideFunctionMenu
  },
  computed: {
    menu() {
      return this.$store.state.uwMotorParam.menu
    }
  },
  mixins: [
    MessageMixin
  ]
}
